import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export interface IPane {
	name: string;
	value: string;
	icon?: React.ReactNode;
	decorator?: string;
	action?: () => void;
}

export const Pane = ({ data }: { data: IPane }) => {
	return (
		<Flex
			justifyContent="flex-start"
			alignItems="center"
			padding="12px 32px"
			borderRight="1px solid"
			borderColor="backgroundSecondary"
			gridGap="32px"
			fontSize="12px"
			lineHeight="1.3em"
			_first={{ paddingLeft: '0' }}
			_last={{ paddingRight: '0', border: 'none' }}
		>
			<Flex
				gridGap="24px"
				alignItems="center"
			>
				{data.icon ?? null}
				<Text
					textTransform="uppercase"
					opacity=".6"
				>
					{data.name}
				</Text>
			</Flex>
			<Flex
				fontSize="16px"
				lineHeight="1.4em"
				fontWeight="600"
				alignItems="center"
			>
				<Text color={Color.ACTION}>{data.decorator}</Text>
				{data.action ? (
					<Text
						onClick={data.action}
						fontWeight="500"
						borderRadius="4px"
						textTransform="uppercase"
						cursor="pointer"
						color="action"
						textDecoration="underline"
						fontSize="12px"
						lineHeight="16px"
						letterSpacing=".1em"
					>
						{data.value}
					</Text>
				) : (
					<Text>{data.value}</Text>
				)}
			</Flex>
		</Flex>
	);
};
